import React from 'react'

const EmptyCandidateIcon = () => {
  return (
    <svg
      width="80"
      height="68"
      viewBox="0 0 80 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="12" width="56" height="56" rx="28" fill="#F2F3F5" />
      <mask
        id="mask0_4119_102303"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="28"
        width="24"
        height="24"
      >
        <rect x="16" y="28" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4119_102303)">
        <path
          d="M27 40C25.9 40 24.9583 39.6083 24.175 38.825C23.3917 38.0417 23 37.1 23 36C23 34.9 23.3917 33.9583 24.175 33.175C24.9583 32.3917 25.9 32 27 32C28.1 32 29.0417 32.3917 29.825 33.175C30.6083 33.9583 31 34.9 31 36C31 37.1 30.6083 38.0417 29.825 38.825C29.0417 39.6083 28.1 40 27 40ZM37.4 50.8L34.9 48.3C34.55 48.5 34.175 48.6667 33.775 48.8C33.375 48.9333 32.95 49 32.5 49C31.25 49 30.1873 48.5627 29.312 47.688C28.4373 46.8127 28 45.75 28 44.5C28 43.25 28.4373 42.1873 29.312 41.312C30.1873 40.4373 31.25 40 32.5 40C33.75 40 34.8127 40.4373 35.688 41.312C36.5627 42.1873 37 43.25 37 44.5C37 44.95 36.9333 45.375 36.8 45.775C36.6667 46.175 36.5 46.55 36.3 46.9L38.8 49.4C38.9833 49.5833 39.075 49.8167 39.075 50.1C39.075 50.3833 38.9833 50.6167 38.8 50.8C38.6167 50.9833 38.3833 51.075 38.1 51.075C37.8167 51.075 37.5833 50.9833 37.4 50.8ZM32.5 47C33.2 47 33.7917 46.7583 34.275 46.275C34.7583 45.7917 35 45.2 35 44.5C35 43.8 34.7583 43.2083 34.275 42.725C33.7917 42.2417 33.2 42 32.5 42C31.8 42 31.2083 42.2417 30.725 42.725C30.2417 43.2083 30 43.8 30 44.5C30 45.2 30.2417 45.7917 30.725 46.275C31.2083 46.7583 31.8 47 32.5 47ZM19 48V45.225C19 44.6583 19.1417 44.1333 19.425 43.65C19.7083 43.1667 20.1 42.8 20.6 42.55C21.45 42.1167 22.4083 41.75 23.475 41.45C24.5417 41.15 25.725 41 27.025 41C26.825 41.3 26.6543 41.6207 26.513 41.962C26.371 42.304 26.2583 42.6583 26.175 43.025C26.0417 43.575 25.9833 44.1167 26 44.65C26.0167 45.1833 26.075 45.6333 26.175 46C26.2583 46.3667 26.371 46.7167 26.513 47.05C26.6543 47.3833 26.825 47.7 27.025 48H19Z"
          fill="#999FAC"
        />
      </g>
      <mask
        id="mask1_4119_102303"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="56"
        y="0"
        width="24"
        height="24"
      >
        <rect x="56" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask1_4119_102303)">
        <path
          d="M79.8466 9L78.5871 6.25L75.8162 5L78.5871 3.75L79.8466 1L81.1062 3.75L83.8771 5L81.1062 6.25L79.8466 9ZM79.8466 23L78.5871 20.25L75.8162 19L78.5871 17.75L79.8466 15L81.1062 17.75L83.8771 19L81.1062 20.25L79.8466 23ZM69.7704 20L67.2514 14.5L61.7095 12L67.2514 9.5L69.7704 4L72.2895 9.5L77.8314 12L72.2895 14.5L69.7704 20ZM69.7704 15.15L70.7781 13L72.9444 12L70.7781 11L69.7704 8.85L68.7628 11L66.5964 12L68.7628 13L69.7704 15.15Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default EmptyCandidateIcon
